// `daily` [ROME-8381]: the warehouse-cost capture chain. Daily is driven by the
// 7-day retention of `sys_serverless_usage` / `sys_query_history` — on the
// existing 2-day rhythm three consecutive failures would lose usage data
// permanently, where daily tolerates six.
export const scheduleTypes = ['daily', 'first-day-of-month'] as const;
